import request from '@/CommonDP/utils/request';
export default {
  // 获取字典组织列表
  getDicList(dicName) {
    return request.get(`/admin/dic/getDicList?dicName=${dicName}`);
  },

  // 获取字典右边列表
  getDicContentList(params) {
    return request.get('/admin/dic/getDicContentList', { params });
  },
  // 新增分组
  saveDicList(params) {
    return request
      .post(`/admin/dic/saveDicList`, params)
      .then((res) => res);
  },
  // 删除分组
  delDicList(params) {
    return request
      .post(`/admin/dic/delDicList`, params)
      .then((res) => res);
  },
  // 修改分组
  updateDicList(params) {
    return request
      .post(`/admin/dic/updateDicList`, params)
      .then((res) => res);
  },
  // 分组下的的字典添加
  addDicContent(params) {
    return request
      .post(`/admin/dic/addDicContent`, params)
      .then((res) => res);
  },
  addDicItem(params) {
    return request.post(`/admin/dic/addDicItem`, params);
  },
  // 分组下的的字典修改
  updateDicContent(params) {
    return request
      .post(`/admin/dic/updateDicContent`, params)
      .then((res) => res);
  },
  updateDicItem (params) {
    return request.post(`/admin/dic/updateDicItem`, params);
  },
  // 字典详情
  getDicContentByID(params) {
    return request.get(`/admin/dic/getDicContentByID`, { params });
  },
  // 分组详情
  getDicInfo(params) {
    return request.get('/admin/dic/getDicInfo', { params });
  },
  // 分组下的的字典删除
  delDicContentByID(params) {
    return request
      .post(`/admin/dic/delDicContentByID`, params)
      .then((res) => res);
  },
  batchAddDicItem (dicCode, params) {
    return request.post(`/admin/dic/dicItem/add/batch?dicCode=${dicCode}`, params);
  },
  dicContentExport(params) {
    return request({
      responseType: "blob",
      url: "/dic/content/export",
      method: "post",
      data: params
    });
  },
  dicContentImport(params) {
    return request.post(`/dic/content/import`, params);
  }
};
